import { render, staticRenderFns } from "./AdvertiserDashboardListTable.vue?vue&type=template&id=2da07cd0&scoped=true"
import script from "./AdvertiserDashboardListTable.vue?vue&type=script&lang=js"
export * from "./AdvertiserDashboardListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da07cd0",
  null
  
)

export default component.exports